import React, { Component } from 'react';
import { Modal, Spin, Empty , message} from 'antd';
import ButtonItem from './ButtonItem';
import { DownloadOutlined } from '@ant-design/icons';
import { connect } from "react-redux";

import axios from 'axios';
class ModalPrevisualizarArchivos extends Component {
  state = {
    loading: false,
    fileData: { 
        type: null,    
        url: null,      
        content: null,  
        base64: null,
        mime: null,
        name: null,
    },
  };

  _currentFileIdentifier = null;

  componentDidMount() {
    if (this.props.file && this.props.visible) {
      this.loadFile(this.props.file);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible && this.props.file) {
      this.loadFile(this.props.file);
    }

    if (!this.props.visible && prevProps.visible) {
      this.cleanup();
    }
  }

  componentWillUnmount() {
    this.cleanup();
  }

  cleanup = () => {
    if (this.state.fileData.url) {
      URL.revokeObjectURL(this.state.fileData.url);
    }
    this.setState({
      fileData: {
        type: null,
        url: null,
        content: null,
        base64: null,
        mime: null,
        name: null,
      },
    });
  };


loadFile = (file) => {
    this.setState({ loading: true });

    // Archivos nuevos 
    if (file instanceof File || (file.size && !file.originFileObj && !file.url)) {
      this.loadFromLocalFile(file, file.name);
      return;
    }

    if (file.originFileObj instanceof File) {
      this.loadFromLocalFile(file.originFileObj, file.name);
      return;
    }

    if (file.url && file.url.startsWith("data:")) {
        const mime = file.url.split(";")[0].split(":")[1];
        const type = mime.startsWith("image/") ? "image" : mime === "application/pdf" ? "pdf" : "unsupported";
        this.setState({
            loading: false,
            fileData: { type, url: file.url, name: file.name, mime }
        });
        return;
    }

    if (file.url && (file.url.startsWith("http://") || file.url.startsWith("https://"))) {
      const isPdf = file.url.toLowerCase().includes('.pdf') || file.mime === 'application/pdf';
      this.setState({
        loading: false,
        fileData: { 
          type: isPdf ? 'pdf' : 'unsupported', 
          url: file.url, 
          name: file.name || 'Etiqueta.pdf',
          mime: 'application/pdf' 
        }
      });
      return;
    }
    
    // Archivos del backend
    if (file.cargadoDesdeBackend && file.urlRelativa) {
      this.loadFromBackend(file);
      return;
    }

    this.setState({ loading: false });
    message.warning("Archivo no soportado.");
  };

  loadFromLocalFile = async (file, name) => {
    const extension = name.split(".").pop().toLowerCase();
    const mime = file.type;

    try {
      // XML
      if (extension === "xml" || mime.includes("xml")) {
        const text = await file.text();
        this.setState({
          loading: false,
          fileData: {
            type: "xml",
            content: text,
            name,
          },
        });
        return;
      }

      // Imagen / PDF
      const blobUrl = URL.createObjectURL(file);
      const type =
        mime.startsWith("image/")
          ? "image"
          : mime === "application/pdf"
          ? "pdf"
          : "unsupported";

      this.setState({
        loading: false,
        fileData: {
          type,
          url: blobUrl,
          mime,
          name,
        },
      });
    } catch (err) {
      console.error(err);
      this.setState({ loading: false, fileData: { type: "error" } });
    }
  };


  loadFromBackend = (file) => {
  // endpointArchivo/parametrosArchivo permiten usar este modal desde modulos que no
  // estan en la cadena de abajo (p.ej. las cotizaciones de requisicion), sin tener que
  // agregarle una rama por cada modulo nuevo.
  const endpoint = this.props.endpointArchivo
    ? this.props.endpointArchivo
    : this.props.empleadoId
    ? "empleados/obtenerArchivoEmpleadoBase64"
    : this.props.pedidoId
      ? "pedidos/obtenerArchivoPedidoBase64"
      : this.props.proveedorId
        ? "proveedores/obtenerArchivoProveedorBase64"
        : "clientes/obtenerArchivoClienteBase64";
  axios
    .post(
      endpoint,
      {
        empresaId: this.props.empresaId,
        proveedorId: this.props.proveedorId,
        clienteId: this.props.clienteId,
        pedidoId: this.props.pedidoId,
        empleadoId: this.props.empleadoId,
        ...(this.props.parametrosArchivo || {}),
        archivoPath: file.urlRelativa,
      },
      { headers: this.props.headersToken }
    )
    .then((res) => {
      const data = res?.data;
      if (!data || !data.base64) {
        message.warning("No se pudo cargar el archivo.");
        this.setState({ loading: false });
        return;
      }

      const { base64, mime, name } = data;

      let type = "unsupported";

      if (mime?.includes("xml")) {
        type = "xml";
      } else if (mime === "application/pdf") {
        type = "pdf";
      } else if (mime?.startsWith("image/")) {
        type = "image";
      } else if (
        mime ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        name?.toLowerCase().endsWith(".xlsx")
      ) {
        type = "xlsx";
      } else if (
        mime ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
        name?.toLowerCase().endsWith(".docx")
      ) {
        type = "docx";
      }

      if (type === "xml") {
        const text = atob(base64);
        this.setState({
          loading: false,
          fileData: {
            type: "xml",
            content: text,
            base64,
            mime,
            name,
          },
        });
        return;
      }

      if (type === "xlsx" || type === "docx") {
        this.setState({
          loading: false,
          fileData: {
            type,
            base64,
            mime,
            name,
          },
        });
        return;
      }

      if (type === "image" || type === "pdf") {
        const byteArray = Uint8Array.from(atob(base64), (c) =>
          c.charCodeAt(0)
        );

        const blob = new Blob([byteArray], { type: mime });
        const blobUrl = URL.createObjectURL(blob);

        this.setState({
          loading: false,
          fileData: {
            type,
            url: blobUrl,
            base64,
            mime,
            name,
          },
        });
        return;
      }

      this.setState({
        loading: false,
        fileData: { type: "unsupported" },
      });
    })
    .catch((err) => {
      console.error("Error obteniendo archivo:", err);
      message.error("Error al consultar el archivo en el servidor.");
      this.setState({ loading: false, fileData: { type: "error" } });
    });
};


  downloadFile = () => {
    const { fileData } = this.state;
    if (!fileData) return;

    let blob;

    if (fileData.type === "xml") {
      blob = new Blob([fileData.content], {
        type: "text/xml;charset=utf-8",
      });
    } else if (fileData.base64) {
      const byteArray = Uint8Array.from(atob(fileData.base64), (c) =>
        c.charCodeAt(0)
      );
      blob = new Blob([byteArray], { type: fileData.mime });
    } else if (fileData.url) {
      fetch(fileData.url)
        .then((r) => r.blob())
        .then((b) => this.forceDownload(b, fileData.name));
      return;
    }

    this.forceDownload(blob, fileData.name);
  };

  forceDownload = (blob, name) => {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = name || "archivo";
    a.click();
    URL.revokeObjectURL(url);
  };


  renderContent = () => {
    const { loading, fileData } = this.state;
    const { file } = this.props;

    if (loading) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <Spin size="large" />
        </div>
      );
    }

    switch (fileData.type) {
      case "image":
        return (
          <img
            src={fileData.url}
            alt={file?.name || "preview"}
            style={{
              maxWidth: "100%",
              maxHeight: "100%",
              display: "block",
              margin: "auto",
            }}
          />
        );

      case "pdf":
        return (
          <embed
            src={fileData.url}
            type="application/pdf"
            width="100%"
            height="100%"
          />
        );

      case "xml":
        return (
          <pre
            style={{
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
              height: "100%",
              overflowY: "auto",
              backgroundColor: "#f5f5f5",
              padding: "15px",
              borderRadius: "4px",
              margin: 0,
              fontFamily: "monospace",
              fontSize: "13px",
            }}
          >
            <code>{fileData.content}</code>
          </pre>
        );

      case "error":
        return <Empty description="Error al cargar el archivo" />;

      default:
        return (
          <Empty description="La previsualización no está disponible para este tipo de archivo." />
        );
    }
  };

  render() {
    const { visible, onClose } = this.props;
    const { fileData, loading } = this.state;

    const footerButtons = [
       <ButtonItem key="close" onClick={onClose} blanco>
            Cerrar
          </ButtonItem>,
          !loading && fileData?.type && fileData.type !== "unsupported" && (
            <ButtonItem
              key="download"
              type="primary"
              icon={<DownloadOutlined />}
              onClick={this.downloadFile}
            >
              Descargar
            </ButtonItem>
          ),
    ];

    return (
      <Modal
        title={fileData?.name || "Previsualización"}
        visible={visible}
        onCancel={onClose}
        footer={footerButtons}
        width="80%"
        style={{ top: 20 }}
        bodyStyle={{ height: "80vh", padding: 0 }}
        destroyOnClose={true}
      >
        {this.renderContent()}
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(ModalPrevisualizarArchivos);
